import streamApi from "@/api/streamApi";

export default {
  state: {
    data: 0,
    topic: "speedoverride"
  },
  getters: {
    data: state => state.data,
    topic: state => state.topic
  },
  actions: {
    subscribe: ({ commit }, machine) => {
      let ch = "SpeedOverride";

      if (machine) {
        // New Data Model
        let family = machine.MachineFamily ? machine.MachineFamily.toLowerCase() : "";
        // Check CMS
        if (!!machine.Manufacturer && machine.Manufacturer.toLowerCase().includes("cms")) {
          family = "cms";
        }

        // Eval if CDL o FORAT o CMS
        if (
          ["bor", "boring", "boring_machine"].indexOf(family) > -1 ||
          ["cnc_machine", "cdl", "cms"].indexOf(family) > -1
        ) {
          ch = "RapidOverride";
        } else {
          ch = "SpeedOverride";
        }

        streamApi.subLatest(machine.Id, `Machine/Cnc/CncProcesses/01/${ch}`, function (pub) {
          let _data = pub.data.v;
          _data = Math.round(_data * 100) / 100;
          commit("UPDATE", _data);
        });
        commit("UPDATE_TOPIC", ch.toLowerCase());
      }
    },

    unsubscribe: ({ commit }, machine) => {
      if (machine) {
        streamApi.unsub(machine.Id, "Machine/OperatingGroups/Override", () => {});
        streamApi.unsub(machine.Id, "Machine/Cnc/CncProcesses/01/SpeedOverride", () => {});
        streamApi.unsub(machine.Id, "Machine/Cnc/CncProcesses/01/RapidOverride", () => {});
        commit("RESET");
      }
    }
  },
  mutations: {
    UPDATE_TOPIC: (state, payload) => {
      state.topic = payload;
    },
    UPDATE: (state, payload) => {
      state.data = payload;
    },
    RESET: state => {
      state.data = 0;
      state.topic = "speedoverride";
    }
  },
  namespaced: true
};
